import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, Download, Mail, ArrowRight, FileText, ShoppingBag } from 'lucide-react';

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div data-testid="payment-success-page" className="min-h-screen bg-[#FAFAF8] py-16">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-2xl">
        <div className="bg-white rounded-3xl p-8 md:p-12 text-center border border-slate-100 shadow-lg">
          {/* Success Icon */}
          <div className="w-24 h-24 bg-[#E8F5E9] rounded-full flex items-center justify-center mx-auto mb-8">
            <CheckCircle className="w-14 h-14 text-[#4CAF50]" />
          </div>

          {/* Title */}
          <h1 className="text-3xl md:text-4xl font-['Poppins'] font-bold text-[#2D3748] mb-4">
            Mokėjimas sėkmingas!
          </h1>
          <p className="text-lg text-[#718096] mb-8">
            Ačiū už pirkimą. Jūsų užsakymas apdorotas.
          </p>

          {/* Order Info */}
          {orderId && (
            <div className="bg-[#FAFAF8] rounded-2xl p-6 mb-8">
              <p className="text-sm text-[#718096] mb-1">Užsakymo numeris</p>
              <p className="text-xl font-bold text-[#2D3748]">{orderId}</p>
            </div>
          )}

          {/* Download Info */}
          <div className="bg-[#E8F5E9] rounded-2xl p-6 mb-8">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <Mail className="w-6 h-6 text-[#4CAF50]" />
              <h3 className="text-lg font-semibold text-[#2D3748]">Patikrinkite el. paštą</h3>
            </div>
            <p className="text-[#718096]">
              Produktų atsisiuntimo nuorodos išsiųstos į jūsų el. paštą. 
              Taip pat galite atsisiųsti produktus iš savo paskyros.
            </p>
          </div>

          {/* What's Next */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
            <div className="bg-[#FFF3E0] rounded-2xl p-5 text-left">
              <Download className="w-8 h-8 text-[#FF9F43] mb-3" />
              <h4 className="font-semibold text-[#2D3748] mb-1">Atsisiųsti</h4>
              <p className="text-sm text-[#718096]">Atsisiųskite produktus iš el. laiško arba paskyros</p>
            </div>
            <div className="bg-[#E3F2FD] rounded-2xl p-5 text-left">
              <FileText className="w-8 h-8 text-[#5B9BD5] mb-3" />
              <h4 className="font-semibold text-[#2D3748] mb-1">Sąskaita</h4>
              <p className="text-sm text-[#718096]">Sąskaita faktūra išsiųsta į el. paštą</p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/parduotuve"
              className="inline-flex items-center justify-center bg-[#4CAF50] text-white hover:bg-[#43A047] rounded-full px-8 py-4 font-semibold transition-colors"
            >
              <ShoppingBag className="w-5 h-5 mr-2" />
              Tęsti apsipirkimą
            </Link>
            <Link
              to="/"
              className="inline-flex items-center justify-center bg-white text-[#2D3748] border-2 border-slate-200 hover:border-[#4CAF50] rounded-full px-8 py-4 font-semibold transition-colors"
            >
              Grįžti į pradžią
              <ArrowRight className="w-5 h-5 ml-2" />
            </Link>
          </div>

          {/* Support Note */}
          <p className="text-sm text-[#718096] mt-8">
            Klausimai? Susisiekite: <a href="mailto:info@tavoemocijos.lt" className="text-[#4CAF50] hover:underline">info@tavoemocijos.lt</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
